export const PRODUCTS = [
  {
    id: "zyn-6mg",
    name: "ZYN 6 MG",
    description:
      "Tobacco-free 6mg nicotine pouches in a wide range of refreshing flavors for a clean, smoke-free experience.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/4xfcpgo8_zyn_discovery_pack_6mg.webp",
    fit: "contain",
    tag: "New",
    viewDetails: true,
  },
  {
    id: "alp-6mg",
    name: "ALP 6 MG",
    description:
      "Premium 6mg tobacco-free nicotine pouches with a smooth, long-lasting flavor and comfortable fit.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/gsz9wtow_ALP-MountainWintergreen-6mg-01.webp",
    fit: "contain",
    tag: "New",
    viewDetails: true,
  },
  {
    id: "alp-9mg",
    name: "ALP 9 MG",
    description:
      "Stronger 9mg tobacco-free nicotine pouches offering bold flavor and a satisfying, steady release.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/uwuhkvng_Alp-chilled-mint-2.webp",
    fit: "contain",
    tag: "New",
    viewDetails: true,
  },
  {
    id: "velo-9mg",
    name: "VELO 9 MG",
    description:
      "9mg tobacco-free nicotine pouches with crisp, modern flavors and a discreet, slim format.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/38il6yrs_images-2.jpeg",
    fit: "contain",
    tag: "New",
    viewDetails: true,
  },
  {
    id: "velo-6mg",
    name: "VELO 6 MG",
    description:
      "6mg tobacco-free mini nicotine pouches delivering smooth flavor in a compact, comfortable size.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/um85y6gg_OPENPACK3.webp",
    fit: "contain",
    tag: "New",
    viewDetails: true,
  },
  {
    id: "geek-bar",
    name: "Geek Bar",
    description: "Premium disposable vape with an excellent flavor selection.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/tasc45wi_geek-bar-pulse-x-grp.webp",
    fit: "contain",
    tag: "Bestseller",
  },
  {
    id: "razz-ltx",
    name: "Razz LTX",
    description: "Advanced disposable vape with long-lasting performance.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/k8mi1bzt_RAZ-LTX-25000-Geek-Vape-347050768.webp",
    fit: "contain",
    tag: "",
  },
  {
    id: "razz-vue-kit",
    name: "RAZZ VUE Kit",
    description: "Rechargeable pod device designed for daily use.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/g7i6tezx_RAZ-VUE-50K-Full-Kit_00-800x800__68447.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "razz-vue-pods",
    name: "RAZZ VUE Pods",
    description: "Replacement flavor pods for the RAZZ VUE system.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/fnclgecw_VUE_Pods_Web_Square-800x800__45772.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "tyn-50k",
    name: "TYN 50K Puffs",
    description: "Powerful disposable vape featuring extended usage and premium flavors.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/ooegq9up_tyn-50k-puff-disposable-strawberry-ice.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "flair-ultra",
    name: "Flair Ultra",
    description: "Premium disposable vape with a sleek design.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/z58ekm7j_flair-ultra-disposable-2500-puffs-banana-ice-2.jpg",
    fit: "contain",
    tag: "",
  },
  {
    id: "flair-plus",
    name: "Flair Plus",
    description: "Modern disposable vape with enhanced battery life.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/cyfmwa9z_smok-city-e-cigs-flair-plus-disposable-device-800-puffs-cheapest-vape-pen-at-12-99-19255075012771.png",
    fit: "contain",
    tag: "",
  },
  {
    id: "flair-pods",
    name: "Flair Pods",
    description: "Replacement pods compatible with Flair devices.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/s1m0dm46_1674478023_infinity-pod-cherry-2.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "feel-free-classic",
    name: "Feel Free Classic",
    description: "Plant-based kava & kratom herbal wellness tonic.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/d09ytlcr_feel_free_CLASSIC_Tonic_Ingredients.webp",
    fit: "contain",
    tag: "",
  },
  {
    id: "kanva-focus-flow",
    name: "Kanva Botanicals Focus + Flow",
    description: "Kava & kratom herbal supplement blend crafted for focus and calm.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/f78gtm3h_Kanva_F_F_Bottle_Final-Front_view_copy.webp",
    fit: "contain",
    tag: "",
  },
  {
    id: "opia-chewable-tablets",
    name: "Opia 7-Hydroxymitragynine Chewable Tablets",
    description: "Flavored chewable tablets available in Wild Cherry, Sour Apple, Classic, Blue Raspberry, and Mintopia.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/7zavxdnz_OPIA_7OH_CHEWABLE__99009.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "kama-cherry-1000",
    name: "Kama 7-Hydroxy + Pseudoindoxyl 1000mg — Cherry",
    description: "Advanced kratom alkaloid tablets in a bold cherry flavor. 20 servings, 200mg per tablet.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/kzoix9hz_images.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "kama-mango-500",
    name: "Kama 7-Hydroxy + Pseudoindoxyl 500mg — Mango",
    description: "Advanced kratom alkaloid tablets in a smooth mango flavor. 20 servings, 100mg per tablet.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/2hr2t69z_Kama-7-Hydroxy-Chewable-Kratom-Tablets-Pseudoindoxyl-500MG_3__06822.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "edp-7oh",
    name: "EDP 7OH Extract",
    description: "Electro Dream Plant 7OH liquid extract from Mitragyna Speciosa, in 30ml and 15ml bottles.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/5gj3tzmg_i.shgcdn.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "wave-turbo-25000",
    name: "Wave Turbo 25000",
    description: "High-capacity Turbo disposable vape delivering up to 25,000 puffs with a carbon-fiber finish and dual display.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/7rqwn9l1_minty_o.png",
    fit: "contain",
    tag: "",
  },
  {
    id: "lost-mary-mt15000",
    name: "Lost Mary MT15000 Turbo",
    description: "Turbo-powered disposable vape with up to 15,000 puffs, available in Watermelon Ice, Blue Razz Ice, and Strawberry Orange.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/y2b5k5er_e91b2c3b-e5fc-410c-8539-8ce9e7ee48ba-1.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "foger-switch-pro",
    name: "Foger Switch Pro",
    description: "Premium disposable vape with adjustable Boost/Normal modes and a full-color display. Shown in Blue Razz Ice.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/0jre8dki_blue-razz-foger-switch-pro.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "cali-8000-puffs",
    name: "Cali 8000 Puffs",
    description:
      "Compact disposable vape offering up to 8,000 puffs with smooth airflow, rich flavor options, and reliable all-day performance.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/czjyvwdw_Cali_Pods_Disposable_Vape_15__59809.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "cali-20000-puffs",
    name: "Cali 20000 Puffs",
    description:
      "High-capacity disposable vape designed for extended use, featuring long-lasting battery life, premium flavors, and consistent performance.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/uffkrrzr_Cali_UL20000_Vape__35863.webp",
    fit: "contain",
    tag: "",
  },
  {
    id: "cali-xlt",
    name: "Cali XLT",
    description:
      "Premium disposable vape with an advanced design, extended battery life, and bold flavor delivery for a superior vaping experience.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/l3tpac0a_CaliPodsCaliXLT40KGallery.webp",
    fit: "contain",
    tag: "",
  },
  {
    id: "aries-neo-50k",
    name: "Aries Neo 50K Puffs",
    description:
      "A premium high-capacity disposable vape offering up to 50,000 puffs, advanced airflow, rechargeable convenience, and long-lasting flavor performance.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/wbddiabs_images.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "yme-0-2700",
    name: "YME 0% 2700",
    description:
      "A nicotine-free disposable vape delivering approximately 2,700 puffs with smooth draws and refreshing flavors for those seeking a tobacco-free vaping experience.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/wc9celee_yme-qb-xxl-disposable-devices.jpeg",
    fit: "contain",
    tag: "0% Nicotine",
  },
  {
    id: "lava-plus",
    name: "Lava Plus",
    description:
      "A stylish disposable vape featuring rich flavors, dependable battery life, and a compact design for everyday convenience.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/saiovwel_images-1.jpeg",
    fit: "contain",
    tag: "",
  },
  {
    id: "geek-bar-burj-80k",
    name: "Geek Bar Burj 80K Puffs",
    description:
      "A next-generation disposable vape with an ultra-high puff capacity of up to 80,000 puffs, premium flavor technology, rechargeable battery, and an advanced display for an exceptional vaping experience.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/o1dj0jp9_geek-bar-burj-khalefa-gum-mint-hookah-style-60000-puffs-pink-theme..webp",
    fit: "contain",
    tag: "",
  },
  {
    id: "geek-bar-pulse",
    name: "Geek Bar Pulse",
    description:
      "One of the most popular disposable vapes, featuring dual vaping modes, rechargeable battery, excellent flavor consistency, and a modern smart display.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-smoke-maple/artifacts/ade6bjjq_GeekBarPulse2Disposable_2bb84e55-8929-458a-a1ac-0f87344ef0c9.webp",
    fit: "contain",
    tag: "Bestseller",
  },
];

export const REVIEWS = [
  {
    name: "Srinath Reddy",
    rating: 5,
    text: "I love the variety, the quality of the products, and the prices are great.",
  },
  {
    name: "Kyra Webb",
    rating: 5,
    text: "Friendly service, great vibe, and a solid selection.",
  },
  {
    name: "Kimberly Zimmerman",
    rating: 5,
    text: "Amazing place — love the people that work here.",
  },
];

export const BUSINESS = {
  name: "SMOK CITY",
  addressLine1: "411 West Trenton Avenue",
  addressLine2: "Morrisville, PA 19067",
  phone: "(610) 332-7061",
  phoneNote: "",
  mapsLink: "https://maps.google.com/?cid=17806788230687653718",
  mapsEmbed:
    "https://www.google.com/maps?q=411+West+Trenton+Avenue+Morrisville+PA+19067&output=embed",
  hours: [
    { day: "Monday – Saturday", time: "9:00 AM – 9:00 PM" },
    { day: "Sunday", time: "10:00 AM – 9:00 PM" },
  ],
  instagram: "https://www.instagram.com/smokcity_pa",
};
